// ============================================================================
// SchedulingDayBox 상수 정의
// ============================================================================

export const UPDATE_INTERVAL = 25000 // 현재 시간 업데이트 간격 (밀리초)
export const SLOT_HEIGHT = 34 // 타임라인 슬롯 높이 (픽셀)
export const MIN_SELECTION_MINUTES = 30 // 최소 선택 시간 (분)
export const MAX_SELECTION_MINUTES = 480 // 최대 선택 시간 (분, 8시간)
export const HANDLE_SIZE = 8 // 리사이즈 핸들 크기 (픽셀)
export const CLICK_THRESHOLD = 15 // 클릭/드래그 구분 임계값 (픽셀)
export const DEFAULT_SCROLL_POSITION = 480 // 기본 스크롤 위치 (7AM, 픽셀)
export const SCROLL_OFFSET = 100 // 현재 시간 기준 스크롤 오프셋 (픽셀)
export const MINUTES_PER_SLOT = 30 // 슬롯당 분 수
export const ADJACENT_MERGE_THRESHOLD = 60000 // 병합 임계값 (밀리초, 1분)
